import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    FormInstance,
    Cascader,
    TreeSelect,
    Spin,
    Space,
    Button,
    Row,
    Col,
    Upload,
    notification, Select, Table, Radio, Tooltip, Tag
} from "antd";
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { 
    deleteTemplateLock, addTemplateLock, getTemplateLock, getTemplateLockOptions 
} from "../../../axios/api.device"
import { gaEvent } from "../../../withTracker"
import { UploadChangeParam } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";

const { Column } = Table;
const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentLock = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [options, setOptions] = useState<any[]>([]);
    const [homeScreenUrl, setHomeScreenUrl] = useState<any>();
    const [showType, setShowType] = useState<string>("iPhone");
    const [modifyImage, setModifyImage] = useState<boolean>(false);
    const [dataForm] = Form.useForm();
    const numberArr = ["第一行", "第二行", "第三行"]
    const [selectKey, setSelectKey] = useState<string>("standard");

    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)

    }
    useEffect(() => {
        Promise.all([getTemplateLockOptions(), getTemplateLock(templateId)]).then(([res1, res2]) => {
            setOptions(res1);
            if (res2 && res2 != null) {
                setShowTable(2)
                var data: any = {};
                if (res2.lockType === "Param") {
                    if (Array.isArray(res2.keys)) {
                        if (res2.keys.length > 2) {
                            data.key1 = res2.keys[0];
                            data.key2 = res2.keys[1];
                            data.key3 = res2.keys[2];
                        } else if (res2.keys.length > 1) {
                            data.key1 = res2.keys[0];
                            data.key2 = res2.keys[1];
                        } else {
                            data.key1 = res2.keys[0];
                        }
                    }
                    setHomeScreenUrl(res2.backgroundUrl);
                } else {
                    data.AssetTag = res2.assetTag;
                }
                setSelectKey(res2.lockType === "Param" ? "parameter" : "standard");
                data.Content = res2.content;
                dataForm?.setFieldsValue(data);
            } else {
                setShowTable(1)
            }
        });
        // getDataInfo();
        // getOptions();

    }, [])
    // const getOptions = () => {
    //     getTemplateLockOptions().then(c => {
    //         setOptions(c)
    //     })
    // }
    const getDataInfo = () => {
        getTemplateLock(templateId).then((res) => {
            if (res && res != null) {
                setShowTable(2)
                var data: any = {};
                if (res.lockType === "Param") {
                    if (res.keys.length > 2) {
                        data.key1 = res.keys[0];
                        data.key2 = res.keys[1];
                        data.key3 = res.keys[2];
                    } else if (res.keys.length > 1) {
                        data.key1 = res.keys[0];
                        data.key2 = res.keys[1];
                    } else {
                        data.key1 = res.keys[0];
                    }
                    setHomeScreenUrl(res.backgroundUrl);
                } else {
                    data.AssetTag = res.assetTag;
                }
                setSelectKey(res.lockType === "Param" ? "parameter" : "standard");
                data.Content = res.content;
                dataForm?.setFieldsValue(data);
            } else {
                setShowTable(1)
            }
        })
    }
    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                var par: any[] = [];
                if (selectKey === "parameter") {
                    var image = res?.image;
                    var imageFile = null;
                    var clearBackground = false;
                    if (image && image.length > 0) {
                        imageFile = image[0].originFileObj;
                    }
                    for (const key of [res.key1, res.key2, res.key3]) {
                        if (key || key === 0) {
                            par.push({ key: "Keys", value: key });
                        }
                    }
                    // if (res.key1) {
                    //     par.push({ key: "Keys", value: res.key1 });
                    // }
                    // if (res.key2) {
                    //     par.push({ key: "Keys", value: res.key2 });
                    // }
                    // if (res.key3) {
                    //     par.push({ key: "Keys", value: res.key3 });
                    // }
                    par.push({ key: "ClearBackground", value: clearBackground });
                    par.push({ key: "Background", value: imageFile });
                } else {
                    if (res.AssetTag) {
                        par.push({ key: "AssetTag", value: res.AssetTag });
                    }
                }
                if (res.Content) {
                    par.push({ key: "Content", value: res.Content });
                }

                par.push({key: "LockType", value: selectKey === "standard" ? "Normal" : "Param"});
                
                addTemplateLock(templateId, par).then(() => {
                    updateTemplate();
                    notification.success({ message: t("成功") });
                    dataForm.resetFields();
                    getDataInfo();
                })
            })
    }
    const deleteTemplateClick = () => {
        deleteTemplateLock(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm?.resetFields();
            getDataInfo();
        })
    }
    const beforeUpload = (file: File) => {
        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
            notification.error({ message: t("You can only upload JPG/PNG file!") });
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            notification.error({ message: t("Image must smaller than 2MB!") });
        }
        return false;
    };
    const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
        //setHomeScreenChanged(true)
        setModifyImage(true)
        getBase64(info.file, (imageUrl: any) => {
            setHomeScreenUrl(imageUrl);
        });
    };
    function getBase64(img: any, callback: any) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
            callback(reader.result);
        });
        reader.readAsDataURL(img);
    }
    // function showTypeChange(e: any) {
    //     setShowType(e.target.value);
    //     drawImage(null);
    // }

    // const imgToBase64 = (url: string) => {
    //     let image = new Image();
    //     //解决跨域
    //     image.crossOrigin = '*';
    //     image.src = url;
    //     return new Promise(resolve => {
    //         image.onload = () => {
    //             var canvas = document.createElement('canvas');
    //             canvas.width = image.width;
    //             canvas.height = image.height;
    //             var context: any = canvas.getContext('2d');
    //             context.drawImage(image, 0, 0, image.width, image.height);
    //             var dataURL = canvas.toDataURL('image/jpeg');
    //             resolve(dataURL);
    //         };
    //     })
    // };

    // function drawImage(imageUrl: any) {
    //     // var opt= ops?ops:options;
    //     dataForm?.validateFields().then(
    //         async (res) => {
    //             var c: any = document.getElementById("mycanvas");
    //             var ctx = c.getContext("2d");
    //             ctx.clearRect(0, 0, c.width, c.height);
    //             console.log("drawImage---imageUrl")
    //             // let img:any =document.getElementById("homeScreen");
    //             // //img.src = imageUrl;
    //             // ctx.drawImage(img,0,0,c.width,c.height );
    //             if (imageUrl) {
    //                 console.log("drawImage---imageUrl")
    //                 let img = new Image();
    //                 img.src = imageUrl;
    //                 ctx.drawImage(img, 0, 0, c.width, c.height);
    //             } else if (homeScreenUrl) {
    //                 console.log("drawImage---homeScreenUrl")
    //                 let img = new Image();
    //                 // var b64 = await imgToBase64(homeScreenUrl)
    //                 img.src = homeScreenUrl;
    //                 ctx.drawImage(img, 0, 0, c.width, c.height);
    //             }

    //             ctx.font = "12px Arial";
    //             var height = 100;
    //             if (res.key1) {
    //                 var value = options.find(c => c.key == res.key1)?.value;
    //                 ctx.fillText(value ?? "", c.width / 2 - value.length * 3, height);
    //                 height += 40;
    //             }
    //             if (res.key2) {
    //                 var value = options.find(c => c.key == res.key2)?.value;
    //                 ctx.fillText(value ?? "", c.width / 2 - value.length * 3, height);
    //                 height += 40;
    //             }
    //             if (res.key3) {
    //                 var value = options.find(c => c.key == res.key3)?.value;
    //                 ctx.fillText(value ?? "", c.width / 2 - value.length * 3, height);
    //                 height += 40;
    //             }
    //             if (res.Content) {
    //                 ctx.fillText(res.Content ?? "", c.width / 2 - res.Content.length * 3, height);
    //                 height += 40;
    //             }
    //         })
    // }
    const normFile = (e: any) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    // const onLoadImage = () => {
    //     drawImage(null);
    // }
    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("锁屏")}</Col>
                {platform != "Android" && (
                    <Col style={{ marginLeft: 36 }}>
                        {templateTab?.availabilities?.map((c: any) => (
                            <Tooltip title={
                                i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                            }>
                                <Tag color="cyan">{c}</Tag>
                            </Tooltip >
                        ))}
                        {templateTab?.supervisedRequired && (
                            <Tooltip title={t("只适用于受监督设备")}>
                                <Tag color="purple">S</Tag>
                            </Tooltip>
                        )}
                    </Col>
                )}
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置锁屏文案")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); gaEvent("templateContentLock", "onClick", "addClick") }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        {/* <Row style={{ width: "100%", margin: 10}}>
                            <Col span={3} offset={1}>{t("锁屏内容")}</Col>
                            <Col span={3}>
                                <Radio.Group buttonStyle="solid" value={selectKey} onChange={(e) => { 
                                    setSelectKey(e.target.value);
                                    dataForm.resetFields();
                                    setHomeScreenUrl("");
                                }}>
                                    <Radio.Button value="standard">{t("标准")}</Radio.Button>
                                    <Radio.Button value="parameter">{t("参数")}</Radio.Button>
                                </Radio.Group>
                            </Col>
                            <Col span={8} style={{ color: "gray", display: "flex", alignItems: "center" }}>
                                <InfoCircleOutlined />&nbsp;&nbsp;
                                <span>{selectKey === "standard" ? t("锁屏信息显示在锁屏界面的底部") : t("生成锁屏壁纸将锁屏文案显示在中间")}</span>
                            </Col>
                        </Row> */}
                        <Form
                            style={{ width: "90%", marginTop: 36 }}
                            layout="horizontal"
                            form={dataForm}
                            labelCol={{ span: 4 }}
                        >
                            {selectKey === "standard" && <>
                                <Item label={t("锁屏信息")} name="Content" rules={[{required: true}]} extra={
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <InfoCircleOutlined />&nbsp;&nbsp;
                                        <span>{t("此信息将展示在锁屏界面底部，文案支持参数，如序列号$(sn), 设备名称$(name), 标签$(tag), UDID $(UDID)")}</span>
                                    </div>
                                }>
                                    <Input />
                                </Item>
                                <Item label={t("资产标签")} name="AssetTag" extra={
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <InfoCircleOutlined />&nbsp;&nbsp;
                                        <span>{t("此信息展示在锁屏信息右侧")}</span>
                                    </div>
                                }>
                                    <Input />
                                </Item>
                            </>}
                            {/* {selectKey === "parameter" && <>
                                <Row>
                                    <Col span={3} offset={1}>
                                        <p>{t("锁屏消息")}</p>
                                    </Col>
                                    <Col span={15}>
                                        <Item label={t("第一行")} name="key1" extra={t("仅用于受监管设备")}>
                                            <Select allowClear>
                                                {options.map(item => (
                                                    <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
                                                ))}
                                            </Select>
                                        </Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={15} offset={4}>
                                        <Item label={t("第二行")} name="key2" >
                                            <Select allowClear >
                                                {options.map(item => (
                                                    <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
                                                ))}
                                            </Select>
                                        </Item>
                                    </Col>
                                </Row>
                                <Row>

                                    <Col span={15} offset={4}>
                                        <Item label={t("第三行")} name="key3" >
                                            <Select allowClear>
                                                {options.map(item => (
                                                    <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
                                                ))}
                                            </Select>
                                        </Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={15} offset={4}>
                                        <Item label={t("自定义消息")} name="Content" >
                                            <Input></Input>
                                        </Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={3} offset={1}>
                                        <p>{t("自定义背景")}</p>
                                    </Col>
                                    <Col span={16} offset={3} >
                                        <Item name="image"
                                            valuePropName="fileList"
                                            getValueFromEvent={normFile}
                                            extra={t("不大于1MB,尺寸512px*512px")}>
                                            <Upload
                                                maxCount={1}
                                                listType="picture-card"
                                                accept=".png,.jpg"
                                                showUploadList={false}
                                                beforeUpload={beforeUpload}
                                                onChange={handleChange}
                                            >
                                                {homeScreenUrl ? (
                                                    <img id="homeScreen" src={homeScreenUrl} alt="avatar" style={{ height: 100 }}

                                                        onLoad={(e: any) => {
                                                            console.log("img--onLoad", e)

                                                        }}
                                                        onChangeCapture={(e: any) => {
                                                            console.log("img--onChange", e)
                                                        }} />
                                                ) : (
                                                    "+"
                                                )}
                                            </Upload>
                                        </Item>
                                    </Col>
                                </Row>
                            </>} */}
                        </Form>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); gaEvent("templateContentLock", "onClick", "addTemplateClick") }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); gaEvent("templateContentLock", "onClick", "deleteTemplateClick") }}>{t("删除规则")}</Button>
                        </div>
                    </>
                )}
            </Row>
        </div>

    </>)
};